import api from "../../utils/api";

/* ======================================================
   GET ALL SONGS (Feed)
====================================================== */

export const getSongs = async (start = 1, limit = 20) => {
  try {
    const res = await api.get("/client/song/getAllSongs", {
      params: { start, limit },
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching songs:", error);
    throw error;
  }
};

/* ======================================================
   GET SONG BY SLUG  ? FIXED
====================================================== */

export const getSongBySlug = async (slug) => {
  try {
    const storedUser = localStorage.getItem("user");
    const userId = storedUser ? JSON.parse(storedUser)._id : null;

    const res = await api.get(`/client/song/getSongBySlug/${slug}`, {
      params: { userId }, // ? IMPORTANT FIX
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching song:", error);
    throw error;
  }
};

/* ======================================================
   TOGGLE LIKE
====================================================== */

export const toggleLikeSong = async (songId) => {
  try {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) throw new Error("Login required");

    const userId = JSON.parse(storedUser)._id;

    const res = await api.post("/client/songLike/toggleLike", {
      songId,
      userId,
    });

    return res.data;
  } catch (error) {
    console.error("Error toggling like:", error);
    throw error;
  }
};

/* ======================================================
   INCREMENT PLAY
====================================================== */

export const incrementPlay = async (songId, listenDuration) => {
  try {
    const res = await api.patch("/client/song/incrementPlay", null, {
      params: { songId, listenDuration },
    });
    return res.data;
  } catch (error) {
    console.error("Error incrementing play:", error);
    throw error;
  }
};

/* ======================================================
   ADD COMMENT
====================================================== */

export const addSongComment = async (songId, comment) => {
  try {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) throw new Error("Login required");

    const userId = JSON.parse(storedUser)._id;

    const res = await api.post("/client/songComment/addComment", {
      songId,
      comment,
      userId,
    });

    return res.data;
  } catch (error) {
    console.error("Error adding comment:", error);
    throw error;
  }
};

/* ======================================================
   GET COMMENTS
====================================================== */

export const getSongComments = async (
  songId,
  start = 1,
  limit = 20
) => {
  try {
    const res = await api.get("/client/songComment/getComments", {
      params: { songId, start, limit },
    });
    return res.data;
  } catch (error) {
    console.error("Error fetching comments:", error);
    throw error;
  }
};

/* ======================================================
   DELETE COMMENT
====================================================== */

export const deleteSongComment = async (commentId) => {
  try {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) throw new Error("Login required");

    const userId = JSON.parse(storedUser)._id;

    const res = await api.delete("/client/songComment/deleteComment", {
      data: { commentId, userId },
    });

    return res.data;
  } catch (error) {
    console.error("Error deleting comment:", error);
    throw error;
  }
};

/* ======================================================
   INCREMENT SHARE
====================================================== */

export const incrementShare = async (songId) => {
  try {
    const res = await api.get("/client/song/incrementShare", {
      params: { songId },
    });
    return res.data;
  } catch (error) {
    console.error("Error incrementing share:", error);
    throw error;
  }
};


/* ======================================================
   GET TRENDING SONGS
====================================================== */

export const getTrendingSongs = async (limit = 20) => {
  try {
    const res = await api.get("/client/song/trending", {
      params: { limit },
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching trending songs:", error);
    throw error;
  }
};


/* ======================================================
   GET RECENT SONGS
====================================================== */

export const getRecentSongs = async (limit = 20) => {
  try {
    const res = await api.get("/client/song/recent", {
      params: { limit },
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching recent songs:", error);
    throw error;
  }
};


/* ======================================================
   GET USER HISTORY (RECOMMENDED)
====================================================== */

export const getUserHistory = async () => {
  try {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return { songs: [] };

    const userId = JSON.parse(storedUser)._id;

    const res = await api.get("/client/song/history", {
      params: { userId },
    });

    return res.data;
  } catch (error) {
    console.error("Error fetching history:", error);
    throw error;
  }
};


/* ======================================================
   GET GENRES
====================================================== */

export const getGenres = async () => {
  try {
    const res = await api.get("/client/song/getGenres");
    return res.data;
  } catch (error) {
    console.error("Error fetching genres:", error);
    throw error;
  }
};